import { FuelData } from "../data/FuelData";
import ProductScore from "./ProductsScore";

export default function StationProducts({data}) {
    const iterableData = Object.entries(data)[Symbol.iterator]();
    let results = [];
    for (const [key, { volume, netto, margin, clients, basket }] of iterableData) {
        const product = FuelData.find(record => record.code === Number(key));
        const obj = { name: product.name, volume, netto, margin, clients, basket, color: product.color, order: product.order }
        results.push(obj);
    };

    return (
        <div className="station-products">
            { results && results.sort((a, b) => a.order - b.order).map((item, index) => <ProductScore data={item} key={index}/>) }
        </div>
    )
}